import React, { Component } from 'react'
import Hero from "../Components/Hero"
import Intro from  "../Components/Intro"
import Footer from "../Components/Footer"

function Gallery() {
    return (
        <div>
        <Hero />
        <Intro />
        <Footer />
        </div>
    )
  }
  
  export default Gallery
